<div class="fix-parent-height-center-center">
  <span class="loader" *ngIf="loadingInfo"></span>
</div>

<div #listParent class="list-parent w-100" [hidden]="loadingInfo">

  <div #listTop class="list-top row m-0">
    <div class="col-12 col-md-6 col-lg-7 p-0 align-self-center mobile-flex-center">
      <span *ngIf="certificateUpload">
        <button class="shadow-lo" mat-raised-button color="primary" (click)="$event.stopPropagation(); uploadCert()">
          <i class="rt-icon rt-cloud-computing-2 fs25 me-1"></i>
          <span>
            {{ 'CERTIFICATES.TABS.PRIVATE.LABELS.UPLOAD' | translate }}
          </span>
        </button>
        <span class="vertical-separator d-inline-block bg-white"></span>
      </span>

      <mat-form-field>
        <input matInput autocomplete="off" (keyup.enter)="$event.stopPropagation(); applyFilter($event.target.value)" [placeholder]="'GLOBAL.SEARCH' | translate" #searchInput />
        <i matSuffix *ngIf="searchInput.value" (click)="$event.stopPropagation(); applyFilter(''); searchInput.value = ''" class="rt-icon rt-cerrar pointer fs18 me-2"></i>
        <i matSuffix (click)="$event.stopPropagation(); applyFilter(searchInput.value)" class="rt-icon rt-search pointer pe-1"></i>
      </mat-form-field>
    </div>

    <div class="col-12 col-lg text-end p-0 align-self-center mobile-flex-center">
      <div class="w-100" *ngIf="rowsCount > 5">
        <mat-paginator
          class="float-end w-100"
          [showFirstLastButtons]="defaultPaginationOpts.showFirstLastButtons"
          [pageSizeOptions]="defaultPaginationOpts.pageSizeOptions"
          [pageSize]="defaultPaginationOpts.pageSize"
          [length]="rowsCount"
          (page)="paginationChange($event)">
        </mat-paginator>
      </div>

      <div *ngIf="rowsCount > 0 && rowsCount <= 5">
        <app-total-page-items [totalItems]="rowsCount"></app-total-page-items>
      </div>
    </div>
  </div>

  <div #listContent [style.height.px]="listDinamycHeight" class="list-content matCustomTable certificates w-100">
    <mat-progress-bar *ngIf="sendingInfo && !loadingInfo" class="table-progress-bar" color="primary"
      mode="indeterminate"></mat-progress-bar>
    <table
      mat-table
      matSort
      matSortDisableClear
      class="agents-table w-100"
      [hidden]="loadingInfo || rowsCount === 0"
      [dataSource]="dataSource"
      [matSortActive]="numberToActiveSortField[userPreference?.orderBy]"
      [matSortDirection]="numberToSortDirection[userPreference?.orderMode]"
      (matSortChange)="sortChange($event)">

      <!-- status Column -->
      <ng-container matColumnDef="active">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="cell-normal"
          (click)="$event.preventDefault(); $event.stopPropagation()">
          {{ 'CERTIFICATES.TABS.PRIVATE.LABELS.STATUS' | translate }}
        </th>
        <td mat-cell *matCellDef="let row" class="cell-normal" [satPopoverAnchor]="tooltipStatus" (mouseenter)="tooltipStatus.open()" (mouseleave)="tooltipStatus.close()">

          <span *ngIf="row.active" class="d-inline-block list-row-icon">
            <i class="rt-icon rt-comprobado-1 fs22 kf-mobile-table-icons"></i>
            <small class="only-mobile ms-1">{{ 'GLOBAL.ENABLED' | translate }}</small>
          </span>
          <span *ngIf="!row.active" class="d-inline-block list-row-icon">
            <i class="rt-icon rt-acceso-denegado-1 fs22 kf-mobile-table-icons"></i>
            <small class="only-mobile ms-1">{{ 'GLOBAL.DISABLED' | translate }}</small>
          </span>

          <sat-popover #tooltipStatus horizontalAlign="start" verticalAlign="above">
            <div style="max-width:300px; word-break: break-all;">
              <div>
                <small class="d-inline-block w-100 px-2 pb-0 fw-bold">
                  {{ 'CERTIFICATES.TABS.PRIVATE.LABELS.STATUS' | translate }}
                </small>
              </div>
              <mat-chip-list class="mat-chip-list-tooltip">
                <mat-chip class="mat-stroked-chip" *ngIf="row.active">
                  <small class="d-inline-block w-100">{{'GLOBAL.ENABLED' | translate}}</small>
                </mat-chip>
                <mat-chip class="mat-stroked-chip" *ngIf="!row.active">
                  <small class="d-inline-block w-100">{{'GLOBAL.DISABLED' | translate}}</small>
                </mat-chip>
              </mat-chip-list>
            </div>
          </sat-popover>
        </td>
      </ng-container>

      <!-- alias Column -->
      <ng-container matColumnDef="alias">
        <th mat-sort-header mat-header-cell *matHeaderCellDef class="cell-normal" (click)="$event.preventDefault(); $event.stopPropagation()">
          {{ 'CERTIFICATES.TABS.PRIVATE.LABELS.NAME' | translate }}
        </th>
        <td mat-cell *matCellDef="let row" class="cell-normal" [satPopoverAnchor]="tooltipAlias" (mouseenter)="tooltipAlias.open()" (mouseleave)="tooltipAlias.close()">
          <div *ngIf="row.alias" class="text-ellipsis-2">
            {{ row.alias }}
          </div>

          <span class="text-ellipsis-2 text-danger" *ngIf="!row.alias">
            {{ 'CERTIFICATES.TABS.PRIVATE.LABELS.NO-NAME' | translate }}
          </span>

          <sat-popover #tooltipAlias horizontalAlign="start" verticalAlign="above">
            <div style="max-width:300px; word-break: break-all;">
              <small class="d-inline-block w-100 p-2" *ngIf="row.alias">
                <b class="fw-bold">{{ 'CERTIFICATES.TABS.PRIVATE.LABELS.NAME' | translate }}: </b> {{row.alias}}
              </small>

              <small class="d-inline-block w-100 p-2 text-danger" *ngIf="!row.alias">
                <b class="fw-bold">{{ 'CERTIFICATES.TABS.PRIVATE.LABELS.NAME' | translate }}: </b> {{'CERTIFICATES.TABS.PRIVATE.LABELS.NO-NAME' | translate}}
              </small>
            </div>
          </sat-popover>
        </td>
      </ng-container>

      <!-- type Column -->
      <ng-container matColumnDef="type">
        <th mat-sort-header mat-header-cell *matHeaderCellDef class="cell-normal" (click)="$event.preventDefault(); $event.stopPropagation()">
          {{ 'CERTIFICATES.TABS.PRIVATE.LABELS.TYPE' | translate }}
        </th>
        <td mat-cell *matCellDef="let row" class="cell-normal" [satPopoverAnchor]="tooltipType" (mouseenter)="tooltipType.open()" (mouseleave)="tooltipType.close()">
          <span *ngIf="row.type === CertificateType.PERSONAL" class="d-inline-block list-row-icon">
            <i class="rt-icon rt-usuario-22 fs22 kf-mobile-table-icons"></i>
            <small class="only-mobile ms-1">{{ 'CERTIFICATES.TABS.PRIVATE.LABELS.CERT-PERSONAL' | translate }}</small>
          </span>
          <span *ngIf="row.type === CertificateType.CORPORATIVE" class="d-inline-block list-row-icon">
            <i class="rt-icon rt-edificio-de-oficinas fs22 kf-mobile-table-icons"></i>
            <small class="only-mobile ms-1">{{ 'CERTIFICATES.TABS.PRIVATE.LABELS.CERT-CORPORATE' | translate }}</small>
            </span>
            <sat-popover #tooltipType horizontalAlign="start" verticalAlign="above">
            <div style="max-width:300px; word-break: break-all;">
              <div>
                <small class="d-inline-block w-100 px-2 pb-0 fw-bold">
                  {{ 'CERTIFICATES.TABS.PRIVATE.LABELS.TYPE' | translate }}
                </small>
              </div>
              <mat-chip-list class="mat-chip-list-tooltip">
                <mat-chip class="mat-stroked-chip" *ngIf="row.type === CertificateType.PERSONAL">
                  <small class="d-inline-block w-100">{{'CERTIFICATES.TABS.PRIVATE.LABELS.CERT-PERSONAL' | translate}}</small>
                </mat-chip>
                <mat-chip class="mat-stroked-chip" *ngIf="row.type === CertificateType.CORPORATIVE">
                  <small class="d-inline-block w-100">{{'CERTIFICATES.TABS.PRIVATE.LABELS.CERT-CORPORATE' | translate}}</small>
                </mat-chip>
              </mat-chip-list>
            </div>
          </sat-popover>
        </td>
      </ng-container>

      <!-- resetPIN Column -->
      <ng-container matColumnDef="resetPIN">
        <th mat-sort-header mat-header-cell *matHeaderCellDef class="cell-normal" (click)="$event.preventDefault(); $event.stopPropagation()">
          {{ 'CERTIFICATES.TABS.PRIVATE.LABELS.RESET-PIN' | translate }}
        </th>
        <td mat-cell *matCellDef="let row" class="cell-normal" [satPopoverAnchor]="tooltipResetPIN" (mouseenter)="tooltipResetPIN.open()" (mouseleave)="tooltipResetPIN.close()">
          <span *ngIf="row.resetPIN" class="d-inline-block list-row-icon">
            <i class="rt-icon rt-contrasena fs22 kf-mobile-table-icons"></i>
            <small class="only-mobile ms-1">{{ 'CERTIFICATES.TABS.PRIVATE.LABELS.RESET-PIN-OK' | translate }}</small>
          </span>
          <span *ngIf="!row.resetPIN" class="d-inline-block list-row-icon">
          <i class="rt-icon rt-seguro fs22 kf-mobile-table-icons"></i>
            <small class="only-mobile ms-1">{{ 'CERTIFICATES.TABS.PRIVATE.LABELS.RESET-PIN-KO' | translate }}</small>
          </span>
          <sat-popover #tooltipResetPIN horizontalAlign="start" verticalAlign="above">
            <div style="max-width:300px; word-break: break-all;">
              <div>
                <small class="d-inline-block w-100 px-2 pb-0 fw-bold">
                  {{ 'CERTIFICATES.TABS.PRIVATE.LABELS.RESET-PIN' | translate }}
                </small>
              </div>
              <mat-chip-list class="mat-chip-list-tooltip">
                <mat-chip class="mat-stroked-chip" *ngIf="row.resetPIN">
                  <small class="d-inline-block w-100">{{'CERTIFICATES.TABS.PRIVATE.LABELS.RESET-PIN-OK' | translate}}</small>
                </mat-chip>
                <mat-chip class="mat-stroked-chip" *ngIf="!row.resetPIN">
                  <small class="d-inline-block w-100">{{'CERTIFICATES.TABS.PRIVATE.LABELS.RESET-PIN-KO' | translate}}</small>
                </mat-chip>
              </mat-chip-list>
            </div>
          </sat-popover>
        </td>
      </ng-container>

      <!-- expiryTime/Valid To Column -->
      <ng-container matColumnDef="expiryTime">
        <th mat-sort-header mat-header-cell *matHeaderCellDef class="cell-normal" (click)="$event.preventDefault(); $event.stopPropagation()">
          {{ 'CERTIFICATES.TABS.PRIVATE.LABELS.VALIDTO' | translate }}
        </th>
        <td mat-cell *matCellDef="let row" class="cell-normal" [satPopoverAnchor]="tooltipExpiryTime" (mouseenter)="tooltipExpiryTime.open()" (mouseleave)="tooltipExpiryTime.close()">
          <span class="text-ellipsis-2" *ngIf="row.expiryTime" [ngClass]="{'text-danger': _utils.isExpired(row.expiryTime)}">
            {{row.expiryTime | dateMultiLang:currentLang}}
          </span>
          <span class="text-ellipsis-2 text-danger" *ngIf="!row.expiryTime">
            {{'GLOBAL.NO-DATE' | translate}}
          </span>
          <sat-popover #tooltipExpiryTime horizontalAlign="start" verticalAlign="above">
            <div style="max-width:300px; word-break: break-all;">
              <small class="d-inline-block w-100 p-2" [ngClass]="{'text-danger': _utils.isExpired(row.expiryTime)}" *ngIf="row.expiryTime">
                <b class="fw-bold">{{ 'CERTIFICATES.TABS.PRIVATE.LABELS.VALIDTO' | translate }}: </b> {{row.expiryTime | dateMultiLang:currentLang}}
              </small>
              <small class="d-inline-block w-100 p-2 text-danger" *ngIf="!row.expiryTime">
                <b class="fw-bold">{{ 'CERTIFICATES.TABS.PRIVATE.LABELS.VALIDTO' | translate }}: </b> {{'GLOBAL.NO-DATE' | translate}}
              </small>
            </div>
          </sat-popover>
        </td>
      </ng-container>

      <!-- columnAction Column -->
      <ng-container matColumnDef="columnAction" stickyEnd>
        <th mat-header-cell *matHeaderCellDef class="cell-final">
          {{'CERTIFICATES.TABS.PRIVATE.LABELS.ACTIONS' | translate}}
        </th>
        <td mat-cell *matCellDef="let row" class="cell-final">
          <button mat-icon-button (click)="$event.stopPropagation();" [matMenuTriggerFor]="columnaction" data-selenium="row-action-btn" [satPopoverAnchor]="tooltipActions" (mouseenter)="tooltipActions.open()" (mouseleave)="tooltipActions.close()" *ngIf="row.capabilities.includes(PersonalCertificateCapabilities.DOWNLOAD) || row.capabilities.includes(PersonalCertificateCapabilities.CHANGE_PIN) || row.capabilities.includes(PersonalCertificateCapabilities.RESET_PIN) || row.capabilities.includes(PersonalCertificateCapabilities.DELETE)">
            <i class="rt-icon rt-more-1 fs-30"></i>
          </button>

          <sat-popover #tooltipActions horizontalAlign="start" verticalAlign="above">
            <div style="max-width:300px; word-break: break-all;">
              <small class="d-inline-block w-100 p-2">
                <b class="fw-bold">{{ 'GLOBAL.ACTIONS' | translate }}</b>
              </small>
            </div>
          </sat-popover>

          <mat-menu #columnaction="matMenu" xPosition="before" yPosition="below" class="profile-menu" [overlapTrigger]="false">

            <button mat-menu-item *ngIf="row.capabilities.includes(PersonalCertificateCapabilities.DOWNLOAD)" [attr.data-selenium]="'button-cert-list-action-download-contract-' + row.id" (click)="$event.stopPropagation(); openDialogConfirmFpBackup(row.requestId)">
              <i class="rt-icon rt-descargar-2 and-text me-2 fs22"></i>
              <span >{{ 'CERTIFICATES.TABS.PRIVATE.LABELS.DOWNLOAD-CERTIFICATE' | translate }}</span>
            </button>
            <mat-divider *ngIf="row.capabilities.includes(PersonalCertificateCapabilities.DOWNLOAD)"></mat-divider>

            <button mat-menu-item *ngIf="row.capabilities.includes(PersonalCertificateCapabilities.CHANGE_PIN)" [attr.data-selenium]="'button-cert-list-action-change-pin-' + row.id" (click)="$event.stopPropagation(); changePin(row.id)">
              <i class="rt-icon rt-edicion and-text me-2 fs22"></i>
              <span >{{ 'GLOBAL.CHANGE-PIN-TITLE' | translate }}</span>
            </button>
            <mat-divider *ngIf="row.capabilities.includes(PersonalCertificateCapabilities.CHANGE_PIN)"></mat-divider>

            <button mat-menu-item *ngIf="row.capabilities.includes(PersonalCertificateCapabilities.RESET_PIN)" [attr.data-selenium]="'button-cert-list-action-reset-pin-' + row.id" (click)="$event.stopPropagation(); resetPin(row.id)">
              <i class="rt-icon rt-contrasena and-text me-2 fs22"></i>
              <span >{{ 'GLOBAL.REGENERATE-PIN-TITLE' | translate }}</span>
            </button>
            <mat-divider *ngIf="row.capabilities.includes(PersonalCertificateCapabilities.RESET_PIN)"></mat-divider>

            <button mat-menu-item *ngIf="row.capabilities.includes(PersonalCertificateCapabilities.REMOVE_PIN)" [attr.data-selenium]="'button-cert-list-action-remove-pin-' + row.id" (click)="$event.stopPropagation(); removeCertPin(row.id, row.alias)">
              <i class="rt-icon rt-contrasena and-text me-2 fs22"></i>
              <span >{{ 'GLOBAL.REMOVE-PIN-TITLE' | translate }}</span>
            </button>
            <mat-divider *ngIf="row.capabilities.includes(PersonalCertificateCapabilities.REMOVE_PIN)"></mat-divider>

            <button mat-menu-item *ngIf="row.capabilities.includes(PersonalCertificateCapabilities.DELETE)" [attr.data-selenium]="'button-cert-list-action-delete-' + row.id" (click)="$event.stopPropagation(); onDeleteIndividualCert(row.id, row.alias)">
              <i class="rt-icon rt-delete and-text me-2 fs22"></i>
              <span >{{ 'GLOBAL.DELETE' | translate }}</span>
            </button>

          </mat-menu>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumnsPersonalCert; sticky: true"></tr>
      <tr class="mat-table-row" mat-row *matRowDef="let row; columns: displayedColumnsPersonalCert" (click)="$event.preventDefault(); $event.stopPropagation()"></tr>
    </table>

    <div *ngIf="rowsCount === 0 && !sendingInfo" class="col-12 px-1 py-0">
      <div *ngIf="dataSource?.filter" class="notify notify-info wb-ball">
        <span class="notify-message text-center">
          {{ 'GLOBAL.NO-RESULTS-FOR' | translate }} <b class="fw-bold">"{{ dataSource.filter }}"</b>.
        </span>
      </div>

      <div *ngIf="!dataSource?.filter" class="notify notify-info wb-ball">
        <span class="notify-message text-center">
          {{ 'GLOBAL.NO-RESULTS' | translate }}
        </span>
      </div>
    </div>
  </div>
</div>
